export default {
  history: {
    issues: [
      {
        id: 'I-GE-EXP-3300',
        domain: 'DKC'
      }
    ],
    triggerValue: 'no'
  },
  understandMedical: {
    issues: [
      {
        id: 'I-GE-EXP-1100',
        domain: 'DKC'
      }
    ],
    triggerValue: 'no'
  },
  understandTreatment: {
    issues: [
      {
        id: 'I-GE-EXP-1200',
        domain: 'DKC'
      }
    ],
    triggerValue: 'no'
  },
  happyWithCare: {
    issues: [
      {
        id: 'I-GE-EXP-1300',
        domain: 'DKC'
      }
    ],
    triggerValue: 'no'
  },
  longTerm: {
    issues: [
      {
        id: 'I-GE-EXP-1400',
        domain: 'DKC'
      }
    ],
    triggerValue: 'yes'
  },
  housing: {
    issues: [
      {
        id: 'I-GE-EXP-1500',
        domain: 'DKC'
      }
    ],
    triggerValue: true
  },
  SNF: {
    issues: [
      {
        id: 'I-GE-EXP-1600',
        domain: 'DKC'
      }
    ],
    triggerValue: true
  },
  DME: {
    issues: [
      {
        id: 'I-GE-EXP-1700',
        domain: 'DKC'
      }
    ],
    triggerValue: true
  },
  sitters: {
    issues: [
      {
        id: 'I-GE-EXP-1800',
        domain: 'DKC'
      }
    ],
    triggerValue: true
  },
  understandHospice: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-GE-EXP-1900',
          domain: 'DGEP',
          triggerValue: 'no'
        },
        {
          id: 'I-GE-EXP-2000',
          domain: 'DGEP',
          triggerValue: 'yes'
        }
      ]
    }
  },
  arrangedFuneral: {
    issues: [
      {
        id: 'I-GE-EXP-2100',
        domain: 'DGEP'
      }
    ],
    triggerValue: 'yes'
  },
  arrangedFuneralHelp: {
    issues: [
      {
        id: 'I-GE-EXP-2200',
        domain: 'DGEP'
      }
    ],
    triggerValue: 'yes'
  },
  realisticPrognosis: {
    issues: [
      {
        id: 'I-GE-EXP-2300',
        domain: 'DKC'
      }
    ],
    triggerValue: 'no'
  },
  realisticTreatment: {
    issues: [
      {
        id: 'I-GE-EXP-2400',
        domain: 'DKC'
      }
    ],
    triggerValue: 'no'
  },
  realisticSymptoms: {
    issues: [
      {
        id: 'I-GE-EXP-2500',
        domain: 'DGEP'
      }
    ],
    triggerValue: 'no'
  },
  copingSkills: {
    issues: [
      {
        id: 'I-GE-EXP-2600',
        domain: 'DGEP'
      }
    ],
    triggerValue: 'no'
  }
}
